import React from "react";
import PropTypes from "prop-types";
import get from "lodash/get";
import { Header } from "../header";
import { Sticky } from "../../basic/sticky";
import { HeaderSearch } from "../header-search";
import {
  CtaWrapper,
  LogoWrapper,
  SecondaryMenu,
  DefaultMenu,
  Sidebar,
  Login,
  Monogram
} from "../header-helper-components";
import { accessCheck } from "../../../../isomorphic/utils";
import { DOUBLE_LAYER_ROOT_MARGIN } from "../../../constants";

import "./header-one.m.css";

const HeaderOne = props => {
  const isSearchFormVisible = get(props, ["header", "isSearchFormVisible"]);
  return (
    <Sticky rootMargin={DOUBLE_LAYER_ROOT_MARGIN}>
      <article styleName="sticky">
        <div styleName="layer-1">
          <div styleName="sidebar">
            <Sidebar {...props} {...props.isSidebarVisible} dataTestId="hamburger-icon-mobile" />
          </div>
          <div styleName="logo">
            <LogoWrapper {...props} />
          </div>
          <div styleName="secondary-menu" data-test-id="secondary_menu">
            <SecondaryMenu {...props} customCssClasses="header-one-secondary" />
          </div>
          <div styleName="cta-login-wrapper">
            <div styleName="cta">
              <CtaWrapper {...props} />
            </div>
            <div styleName="search">
              <HeaderSearch {...props} dataTestId="search-icon-mobile" />
            </div>
            {accessCheck(props.enableSSO) && (
              <div styleName="login">
                <Login {...props} />
              </div>
            )}
          </div>
        </div>
        <div styleName={`layer-2 ${isSearchFormVisible ? "hide-search-form" : ""}`}>
          <div styleName="sidebar">
            <Sidebar {...props} {...props.isSidebarVisible} dataTestId="hamburger-icon" />
          </div>
          <div styleName="monogram">
            <Monogram {...props} />
          </div>
          <div styleName="default-menu" data-test-id="primary_menu">
            <DefaultMenu {...props} />
          </div>
          <div styleName="search">
            <HeaderSearch {...props} dataTestId="search-icon" />
          </div>
        </div>
      </article>
    </Sticky>
  );
};
HeaderOne.propTypes = {
  header: PropTypes.shape({
    isSearchFormVisible: PropTypes.bool
  }),
  isSidebarVisible: PropTypes.bool,
  toggleSearchForm: PropTypes.bool,
  hideSearchForm: PropTypes.bool,
  enableSSO: PropTypes.bool
};

const HeaderTemplate = ({ showHeaderRowOnly = false }) => (
  <Header renderTemplate={HeaderOne} showHeaderRowOnly={showHeaderRowOnly} />
);

HeaderTemplate.propTypes = {
  showHeaderRowOnly: PropTypes.bool
};

export default HeaderTemplate;
